
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { GlobalDataProps } from '../store'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'Home',
  setup () {
    const router = useRouter()
    const store = useStore<GlobalDataProps>()
    const token = computed(() => store.state.token)
    const url = ref('')
    const iframe = ref(null)
    const currentIframeHref = new URL(document.location.href)
    const urlOrigin = currentIframeHref.origin
    const urlFilePath = decodeURIComponent(currentIframeHref.pathname)
    const reLoginUrl = 'https://www.kujiale.com/vc/account/login'
    const reLoginPath = urlOrigin + urlFilePath

    const refreshIntervalId = setInterval(() => {
      // 检查登录是否已过期，过期自动跳转到登录页
      console.log(urlFilePath)
      if (
        urlOrigin === reLoginUrl ||
        // eslint-disable-next-line no-self-compare
        urlFilePath === urlFilePath ||
        reLoginPath === reLoginUrl
      ) {
        router.push('/login')
      }
    }, 5000)

    localStorage.setItem('refreshIntervalId', refreshIntervalId + '')

    onMounted(() => {
      const myiframe = iframe.value as unknown as HTMLIFrameElement
      myiframe.onload = (e) => {
        console.log('页面跳转', e.target)
      }
      // console.log('🍌', myiframe.contentWindow?.location)
    })

    if (token.value) {
      url.value = `https://www.kujiale.com/v/auth?accesstoken=${token.value}&dest=5`
    } else {
      router.push('/login')
    }
    return {
      url,
      iframe
    }
  }
})
